import { ActionButton, Stack, Text } from '@fluentui/react';

import { addIcon } from '../../../../../utils/icons';
import { Product } from '../../../slice/newFormReducers';
import { useColumnOnChangeFn, useColumnSelector } from './hooks';

type Props = {
  uuid: string;
  shipmentEditMode?: boolean;
};

const key: keyof Product = "count";

export default ({ uuid, shipmentEditMode }: Props) => {
  const value = useColumnSelector(uuid, key) || 0;
  const onChange = useColumnOnChangeFn(uuid, key, true);

  return (
    <Stack horizontal verticalAlign="center">
      <Stack.Item>
        <ActionButton
          disabled={value === 1}
          iconProps={{ iconName: "Remove" }}
          onClick={() => onChange(null, Math.max(1, value - 1))}
        />
      </Stack.Item>
      <Stack grow horizontalAlign="center">
        <Text variant="mediumPlus">{value}</Text>
      </Stack>
      <Stack.Item>
        <ActionButton
          iconProps={addIcon}
          onClick={() => onChange(null, Math.min(99, value + 1))}
        />
      </Stack.Item>
    </Stack>
    // <SpinButton
    //   value={value ? value.toString() : ""}
    //   onChange={onChange}
    //   disabled={shipmentEditMode}
    //   min={0}
    //   max={999}
    // />
  );
};
